module.exports = __webpack_public_path__ + "static/media/quienes-somos.93f78b36.png";